// Label Template List Page Translation
export default {
  // Page Title
  title: "Label Template List",

  // Button Text
  buttons: {
    addTemplate: "Add Label Template",
    search: "Search",
    reset: "Reset",
  },

  // Dialog Title
  dialog: {
    addTemplate: "Add Label Template",
  },

  // Search Form
  search: {
    placeholder: "Enter label name to search",
    dateRange: {
      startPlaceholder: "Start Date",
      endPlaceholder: "End Date",
      separator: "→",
    },
  },

  // Table Related
  table: {
    totalData: "records",
    totalPrefix: "Total",
    pagination: {
      itemsPerPage: "per page",
      total: "Total",
      items: "items",
    },
  },

  // Actions
  actions: {
    edit: "Edit",
    delete: "Delete",
    view: "View",
    copy: "Copy",
    download: "Download",
    upload: "Upload",
  },

  // Status Display
  status: {
    public: "Yes",
    private: "No",
    enabled: "Enabled",
    disabled: "Disabled",
  },

  // Messages
  messages: {
    confirmClose: "Confirm to close?",
    deleteConfirm: "Confirm to delete this label template?",
    deleteSuccess: "Deleted successfully",
    saveSuccess: "Saved successfully",
    copySuccess: "Copied successfully",
    noData: "No data available",
    loadError: "Failed to load, please try again later",
  },

  // Form Validation
  validation: {
    nameRequired: "Please enter label name",
    nameLength: "Label name length should be between 2-50 characters",
    descriptionRequired: "Please enter label description",
    descriptionLength: "Description length cannot exceed 200 characters",
  },

  // Table Column Headers
  columns: {
    name: "Label Name",
    description: "Description",
    creator: "Creator Username",
    createTime: "Create Time",
    modifiedTime: "Modified Time",
    propertyPublic: "Property Public",
    status: "Status",
    operations: "Operations",
  },

  // File Upload Related
  upload: {
    resultTitle: "Label Upload Results",
    noUpload: "No uploads yet",
    result: "Upload Result",
    batchResultTitle: "Label Batch Upload Results",
  },

  // Batch modify dialog (alterLabel.vue)
  batchModify: {
    title: "Batch Modify",
    instruction1:
      "Click the download button below to download all conflicting label addresses locally for batch modification;",
    instruction2:
      "Click the upload button below to upload the modified file and sync to the platform.",
    downloadBtn: "Download",
    uploadBtn: "Upload",
    downloadFileName: "Label Batch Download",
    uploadSuccess: "Upload successful!",
    uploadError:
      "Upload failed, please refresh the page and try again, or check the network",
    uploadErrorTitle: "Notice",
    fileTypeError: "Only Excel files can be uploaded",
  },

  // New Label Page (newLabel.vue)
  newLabel: {
    // Form Labels
    form: {
      labelName: "Label Name",
      labelIcon: "Label Icon",
      labelSort: "Label Sort",
      labelPublicType: "Label Public Type",
      propertyPublic: "Property Public",
      labelType: "Label Type",
      addAttribute: "Add Label Attribute",
      canDelete: "Can Delete",
    },

    // Form Placeholders
    placeholders: {
      labelName: "Please enter label name",
      labelSort: "Please enter label sort",
      publicType: "Private",
      propertyPublic: "Yes",
      labelType: "Please select",
      canDelete: "Yes",
    },

    // Option Texts
    options: {
      public: "Public",
      private: "Private",
      yes: "Yes",
      no: "No",
    },

    // Upload Related
    upload: {
      clickToUpload: "+ Click to upload label icon",
      addMultiple: "+ Can add multiple",
    },

    // Hint Texts (originally from CSS pseudo-elements)
    hints: {
      iconSize: "Icon size 100px*100px, max 1M",
      sortRange: "Sort weight 0-9999, smaller number has higher weight",
      publicTypeDesc: "Public: visible to all; Private: visible to self only",
      attributeDesc: "Add attribute fields to label",
    },

    // Button Texts
    buttons: {
      reset: "Reset",
      submit: "Submit",
    },

    // Validation Messages
    validation: {
      nameRequired: "Please enter label name",
      iconRequired: "Please upload label icon",
      sortRequired: "Please enter label sort",
      publicTypeRequired: "Please select label public type",
      propertyPublicRequired: "Please select property public",
      labelTypeRequired: "Please select label type",
      canDeleteRequired: "Please select if can delete",
    },

    // Success Messages
    messages: {
      addSuccess: "Label added successfully!",
      uploadError:
        "Upload failed, please refresh the page and try again, or check network",
      uploadErrorTitle: "Notice",
    },

    // Label Attribute Child Component (moreAttributeChild.vue)
    attributeChild: {
      // Form Labels
      form: {
        attributeName: "Attribute Name",
        required: "Required",
        attributeType: "Attribute Type",
        configureFields: "Configure Attribute Fields",
      },

      // Placeholders
      placeholders: {
        attributeName: "Please enter",
        attributeType: "Please select",
        fieldPlaceholder: "Attribute Field",
        fieldTextPlaceholder: "Please enter attribute field text",
      },

      // Option Texts
      options: {
        yes: "Yes",
        no: "No",
        textInput: "Text Input (Manual)",
        enumField: "Enum Field (Select)",
      },
    },
  },

  // Label result page (labelResult.vue)
  labelResult: {
    // Label upload statistics
    uploadSummary: {
      prefix: "Successfully uploaded",
      middle1: " [",
      middle2: "] label addresses, of which",
      middle3: " addresses already have [",
      middle4:
        "] labels, please check the table below for field conflicts, and",
      suffix: " addresses failed to upload.",
    },

    // Tabs
    tabs: {
      conflictLabel: "Conflict Labels",
      failedLabel: "Failed Upload Labels",
    },

    // Conflict labels section
    conflict: {
      batchModifyBtn: "Batch Modify",
      copySuccess: "Copy successful!",
      originalAttributes: "Original Label Attributes",
      newAttributes: "New Label Attributes",
      placeholderText: "Here is the new remark text",
      mergeBtn: "Merge",
      coverBtn: "Cover",
      batchMergeBtn: "Batch Merge",
      batchCoverBtn: "Batch Cover",
      conflictTotal: "Total conflict labels:",
      conflictTotalSuffix: "",
      prevBtn: "< Previous",
      nextBtn: "Next >",
    },

    // Failed labels section
    failed: {
      addressColumn: "Address",
      labelNameColumn: "Label Name",
      reasonColumn: "Failure Reason",
      failedTotal: "Total failed upload labels:",
      failedTotalSuffix: " pages",
      prevPageBtn: "< Previous Page",
      nextPageBtn: "Next Page >",
    },

    // Empty data state
    empty: {
      text: "No Data",
    },

    // Operation result messages
    operationMessages: {
      mergeSuccess: "Label merge successful!",
      coverSuccess: "Label cover successful!",
      batchMergeSuccess: "Batch merge successful!",
      batchCoverSuccess: "Batch cover successful!",
    },
  },
};
